import React from 'react'

const Container = ({ children }) => (
  <div className="container mx-auto">
    {children}
  </div>
)

export default Container
